import { useTranslation } from "react-i18next";

import { Button } from "@/components/ui/button";

type Props = {
  /** Inside the app shell the error fills the main content; otherwise it owns the screen. */
  inShell: boolean;
  onRetry: () => void;
};

export function ErrorView({ inShell, onRetry }: Props) {
  const { t } = useTranslation();

  return (
    <main
      className={
        inShell
          ? "mx-auto grid w-full max-w-md gap-6 overflow-y-auto p-6"
          : "mx-auto grid min-h-svh max-w-md content-center gap-6 p-6"
      }
    >
      <h1 className="font-heading font-bold text-2xl uppercase leading-tight tracking-[0.01em]">
        {t("Something went wrong")}
      </h1>

      <p className="text-muted-foreground text-sm">
        {t("An unexpected error occurred. Try again, or go back to the start.")}
      </p>

      <div className="flex flex-wrap gap-3">
        <Button onClick={onRetry} size="lg">
          {t("Try again")}
        </Button>
        <Button asChild size="lg" variant="outline">
          <a href="/">{t("Back to home")}</a>
        </Button>
      </div>
    </main>
  );
}
